module.exports = __webpack_public_path__ + "img/prize2.e355edd.png";